import React from 'react';
import { motion } from 'framer-motion';
import { Phone, Hammer, Heart } from 'lucide-react';

const steps = [
  {
    num: '01',
    title: 'You Call',
    icon: Phone,
    desc: 'We listen to your vision, your budget, and your timeline. Free estimates, no pressure, just an honest conversation.',
  },
  {
    num: '02',
    title: 'We Build',
    icon: Hammer,
    desc: 'Our crew shows up on time, protects your home, and executes exactly what we agreed on. Clean job sites, clear communication throughout.',
  },
  {
    num: '03',
    title: 'You Love It',
    icon: Heart,
    desc: "Every detail finished right. We don't leave until the work meets our standard — and yours.",
  },
];

export default function HowItWorks() {
  return (
    <section className="relative py-24 md:py-32 bg-[#0a0a0a] border-t border-white/10">
      <div className="max-w-7xl mx-auto px-5 md:px-8">
        <motion.div
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 0.7 }}
          className="text-center mb-16"
        >
          <div className="w-12 h-px bg-[#C97B2E] mx-auto mb-6" />
          <span className="font-body text-[#C97B2E] text-xs font-bold uppercase tracking-[0.3em] mb-4 block">
            The Process
          </span>
          <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl font-bold text-white">
            How It Works
          </h2>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-0 border-t border-white/10">
          {steps.map((step, i) => (
            <motion.div
              key={i}
              initial={{ opacity: 0 }}
              whileInView={{ opacity: 1 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: i * 0.15 }}
              className="relative border-b md:border-b-0 border-r border-white/10 px-8 md:px-12 py-14 flex flex-col overflow-hidden last:border-r-0"
            >
              {/* Giant decorative number */}
              <span
                className="absolute bottom-4 right-4 font-heading font-bold text-white select-none pointer-events-none"
                style={{ fontSize: '9rem', lineHeight: 1, opacity: 0.04 }}
                aria-hidden="true"
              >
                {step.num}
              </span>

              {/* Icon + Step label */}
              <div className="flex items-center gap-3 mb-6">
                <div className="w-9 h-9 rounded-sm bg-[#C97B2E]/15 flex items-center justify-center flex-shrink-0">
                  <step.icon className="w-4 h-4 text-[#C97B2E]" />
                </div>
                <span className="font-body text-[#C97B2E] text-xs font-bold uppercase tracking-[0.3em]">
                  Step {step.num}
                </span>
              </div>

              {/* Divider */}
              <div className="w-10 h-px bg-[#C97B2E] mb-6" />

              {/* Title */}
              <h3 className="font-heading text-white text-3xl md:text-4xl font-bold mb-5">
                {step.title}
              </h3>

              {/* Description */}
              <p className="font-body text-white/55 text-base leading-relaxed">
                {step.desc}
              </p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}